export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/to-shops-bubble.d1d76429-9ccb9b.svg";